import React from "react";

interface Props {
  data: unknown;
  index: number;
  style: React.CSSProperties;
}

const PlanningMapVirtualizedListItem = React.memo((props: React.PropsWithChildren<Props>) => {
  return <div style={{
    ...props.style,
    height: (props.style.height as number) - 4,
  }}>
    {props.children}
  </div>
}, (prevProps, nextProps) => {
  const { children, ...prevPropsWithoutChildren } = prevProps;
  const { children: nextChildren, ...nextPropsWithoutChildren } = nextProps;
  return JSON.stringify(prevPropsWithoutChildren) === JSON.stringify(nextPropsWithoutChildren);
})

export default PlanningMapVirtualizedListItem;